// =============================================
// src/components/modals/LiveModeModal.jsx
// =============================================

import React from "react";
import { Info, Sparkles } from "lucide-react";
import { styles } from "../../utils/constants";

export default function LiveModeModal({ open, onClose, onConfirm }) {
  if (!open) return null;
  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(15,23,42,0.75)",
          backdropFilter: "blur(4px)",
          zIndex: 999,
        }}
        onClick={onClose}
      />
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "28px",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
          zIndex: 1000,
          border: "1px solid #e2e8f0",
        }}
      >
        <div style={{ marginBottom: "24px" }}>
          <h3
            style={{
              margin: "0 0 12px 0",
              color: "#0f172a",
              fontSize: "20px",
              fontWeight: "700",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Sparkles size={20} color="#f59e0b" /> Enable Live Mode
          </h3>
          <p style={{ color: "#64748b", fontSize: "14px", margin: "0 0 16px 0", lineHeight: 1.6 }}>
            When Real-Time Monitor aka Live Mode is enabled, AlzTxPILOT will:
          </p>
          <ul style={{ margin: "0 0 20px 0", paddingLeft: "20px", color: "#334155", fontSize: "14px", lineHeight: 1.8 }}>
            <li>Monitor for changes in the underlying databases and publications</li>
            <li>Automatically re-run the workflow when changes are detected</li>
            <li>Send notifications when new outputs are generated</li>
          </ul>
          <div
            style={{
              padding: "12px 16px",
              backgroundColor: "#fef3c7",
              borderRadius: "8px",
              border: "1px solid #fbbf24",
              marginBottom: "20px",
            }}
          >
            <p style={{ margin: 0, fontSize: "13px", color: "#92400e", display: "flex", alignItems: "start", gap: "8px" }}>
              <Info size={16} style={{ flexShrink: 0, marginTop: "2px" }} />
              <span>
                This feature will enable continuous monitoring, you are limited to one live query. You'll receive
                notifications through your preferred channel.
              </span>
            </p>
          </div>
        </div>
        <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
          <button
            style={{
              ...styles.button,
              padding: "10px 20px",
              fontSize: "14px",
              backgroundColor: "transparent",
              color: "#64748b",
              border: "2px solid #e2e8f0",
            }}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f8fafc";
              e.currentTarget.style.borderColor = "#cbd5e1";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            Cancel
          </button>
          <button
            style={{
              ...styles.button,
              padding: "10px 20px",
              fontSize: "14px",
              backgroundColor: "#f59e0b",
              color: "white",
              border: "none",
            }}
            onClick={onConfirm}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#d97706";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#f59e0b";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <Sparkles size={16} /> Enable Live Mode
          </button>
        </div>
      </div>
    </>
  );
}

